import { render, staticRenderFns } from "./FieldConfigEdit.vue?vue&type=template&id=4cf3b264&scoped=true"
import script from "./FieldConfigEdit.vue?vue&type=script&lang=js"
export * from "./FieldConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./FieldConfigEdit.vue?vue&type=style&index=0&id=4cf3b264&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf3b264",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cf3b264')) {
      api.createRecord('4cf3b264', component.options)
    } else {
      api.reload('4cf3b264', component.options)
    }
    module.hot.accept("./FieldConfigEdit.vue?vue&type=template&id=4cf3b264&scoped=true", function () {
      api.rerender('4cf3b264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/physicalConfig/fieldConfig/FieldConfigEdit.vue"
export default component.exports